/*
 * @Author: Vanny
 * @Date: 2019-08-01 16:36:12
 * @LastEditors: Vanny
 * @LastEditTime: 2020-07-06 16:27:09
 * @Description: 单据管理-仓库
 */
import { call, put, select } from 'redux-saga/effects';
import moment from 'moment';
import { billFilter, shopFilter } from '../../config/constants';

import { $t } from 'src/tools';
import * as billApi from '../../services/orderApi';
import { fewDayAgo } from '../../utils/date';
import { exportToExcelFromNet } from '../../utils';
import { isMC } from '../../utils/env';

export const initBillConfig = {
  exist: false,
  keyword: '',
  list: [],
  query: {
    type: 'custom',
    sday: moment(fewDayAgo(7)),
    eday: moment(),
  },
  pagination: {
    current: 1,
    pageSize: 50,
    total: 0,
  },
  duokeFilter: {
    filters: [],
    radios: [],
  },
  docReturnInfo: {},
};

const initialState = {
  all: { ...initBillConfig },
  retailSale: { ...initBillConfig },
  retail: { ...initBillConfig },
  sale: { ...initBillConfig },
  purchase: { ...initBillConfig },
  returnGood: { ...initBillConfig },
  returnFactory: { ...initBillConfig },
  spending: { ...initBillConfig },
  preSell: { ...initBillConfig },
  preBuy: { ...initBillConfig },
  transferOrderOut: { ...initBillConfig },
  transferOrderIn: { ...initBillConfig },
  inventory: { ...initBillConfig },
  cashier: { ...initBillConfig },
  bhb: { ...initBillConfig },
};

export const state = initialState;

export const reducers = {
  transformFilter(state, { payload }) {
    const {
      type,
      appState: {
        userInfo: {
          plugins_info: pluginsInfo = [],
          staff_list: staffList = [],
          shop_list: shopList = [],
        },
      },
    } = payload;
    const tagSetting = pluginsInfo.find((p) => p.plugins_id === '124');
    let filters = (
      shopList.length <= 1
        ? []
        : [{ ...shopFilter, options: shopList.map((v) => ({ name: v.name, value: v.id })) }]
    ).concat(billFilter);
    const plugin105 = pluginsInfo.find((p) => p.plugins_id === '105');

    filters = filters.map((filter) => {
      //把订单状态修改为客户端相同
      if (filter?.code === 'edit_status') {
        return {
          name: 'order_status',
          code: 'child',
          options: [
            {
              name: 're_modify',
              value: `{"edit_status": "1"}`,
              key: '1',
            },
            {
              name: 're_price_change',
              value: `{"price_change":"1"}`,
              key: '2',
            },
            {
              name: 're_remark',
              value: `{"doc_remark": "1" }`,
              key: '3',
            },
          ],
        };
      }
      return filter;
    });
    if (!!plugin105) {
      filters = filters.concat([
        {
          name: 'ports',
          code: 'only_staff_id',
          options: staffList
            .filter((v) => v.allow_bind === '1')
            .map((v) => ({ name: v.name, value: v.id })),
        },
      ]);
    }
    filters = filters.concat([
      {
        name: 'order_staff',
        code: 'seller_id',
        options: staffList.map((v) => ({
          name: v.name,
          value: v.id,
        })),
      },
      {
        name: 'order_tag',
        code: 'tag',
        options: Object.keys(tagSetting?.setting ?? {})
          .filter((k) => !!tagSetting.setting[k])
          .map((k) => ({
            name: tagSetting.setting[k],
            value: k,
          })),
      },
    ]);
    const isTransfer = ['transferOrderOut', 'transferOrderIn'].includes(type);
    if (isTransfer && !isMC()) {
      filters = filters.concat([
        {
          name: 'side_order_origin',
          code: 'from',
          options: [
            {
              name: 'Option_staff_saleDevison',
              value: '0',
            },
            {
              name: 'warehouse_send_to_store',
              value: '7',
            },
            {
              name: 'warehouse_send_to_multi_store',
              value: '6',
            },
          ],
        },
      ]);
    }
    const radios = filters.map((f) => f.code);
    state[type].duokeFilter = { filters, radios };
    return { ...state };
  },
};

export const effects = {
  // 获取单据列表
  *getList({ payload }) {
    const billState = yield select((state) => state.billState);

    const { type, ...otherParams } = payload;
    const { pagination, query: q, keyword } = billState[type] || {};
    const query = {
      ...q,
      ...otherParams,
      page: pagination.current,
      page_num: pagination.pageSize,
    };
    const response = keyword
      ? yield call(billApi.requestOrderSearch, {
          id: keyword,
          body: { ...query },
        })
      : yield call(billApi.requestOrderList, query);
    if (response) {
      yield put({
        type: 'bill/setState',
        payload: {
          [type]: {
            ...(billState[type] || {}),
            exist: true,
            list: response.list,
            pagination: { ...billState.pagination, total: parseInt(response.list_num) },
          },
        },
      });
    }
  },
  // 获取订单退货信息
  *getReturnInfo({ payload }) {
    const response = yield call(billApi.requestGetReturnInfo, payload);
    return response?.result?.data ?? {};
  },
  *addReturnDoc({ payload }) {
    const response = yield call(billApi.addReturnDoc, payload);
    return response;
  },
  *getPayment() {
    const response = yield call(billApi.getPayment);
    return response?.list ?? [];
  },
  // 导出单据
  *getExport({ payload }) {
    const billState = yield select((state) => state.billState);
    const { type, showDetail, ...other } = payload;
    const { query: q, keyword } = billState[type] || {};

    const query = {
      ...q,
      ...other,
      keyword,
      out: 'excel',
      async: '0',
      show_detail: showDetail,
    };
    delete query.page;
    delete query.page_num;
    const response = yield call(billApi.requestGetExcel, query);
    if (response) {
      exportToExcelFromNet(response, $t('bill', 'Sider'));
    }
  },
};
